(() => {
  const BUNDLES = [
    { country: 'Maroc', top: 10297857212656, short: 10297857769712, code: 'ENSEMBLE-MAROC' },
    { country: 'Algérie', top: 10297880936688, short: 10297882607856, code: 'ENSEMBLE-ALGERIE' },
    { country: 'Tunisie', top: 10297883459824, short: 10297883885808, code: 'ENSEMBLE-TUNISIE' },
    { country: 'Albanie', top: 10297884180720, short: 10297884442864, code: 'ENSEMBLE-ALBANIE' },
    { country: 'Arménie', top: 10297884868848, short: 10297885982960, code: 'ENSEMBLE-ARMENIE' },
    { country: 'Turquie', top: 10297886834928, short: 10297887326448, code: 'ENSEMBLE-TURQUIE' }
  ];

  const BUNDLE_CODES = new Set(BUNDLES.map((bundle) => bundle.code));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  let syncing = false;
  let scheduled = null;

  const cartUrl = (path) => root + path.replace(/^\//, '');

  function quantityFor(cart, productId) {
    return (cart.items || []).reduce((sum, item) => {
      return sum + (Number(item.product_id) === Number(productId) ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function getActiveCodes(cart) {
    const codes = new Set();

    if (Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach((entry) => {
        if (typeof entry === 'string') codes.add(entry.toUpperCase());
        if (entry && typeof entry.code === 'string' && entry.applicable !== false) {
          codes.add(entry.code.toUpperCase());
        }
      });
    }

    document.querySelectorAll('[data-discount-code]').forEach((element) => {
      const code = element.getAttribute('data-discount-code');
      if (code) codes.add(code.toUpperCase());
    });

    return codes;
  }

  function sameSet(a, b) {
    if (a.size !== b.size) return false;
    for (const value of a) {
      if (!b.has(value)) return false;
    }
    return true;
  }

  async function reconcileBundleDiscounts() {
    if (syncing) return;
    syncing = true;

    try {
      const cartResponse = await nativeFetch(cartUrl('cart.js'), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();

      const desiredBundleCodes = new Set(
        BUNDLES
          .filter((bundle) => quantityFor(cart, bundle.top) > 0 && quantityFor(cart, bundle.short) > 0)
          .map((bundle) => bundle.code)
      );

      const activeCodes = getActiveCodes(cart);
      const activeBundleCodes = new Set([...activeCodes].filter((code) => BUNDLE_CODES.has(code)));

      if (sameSet(activeBundleCodes, desiredBundleCodes)) return;

      const nonBundleCodes = [...activeCodes].filter((code) => !BUNDLE_CODES.has(code));
      const nextCodes = [...nonBundleCodes, ...desiredBundleCodes];

      const response = await nativeFetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: nextCodes.join(',') })
      });

      if (!response.ok) return;

      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent('mamba:bundle-discount-updated'));
    } catch (error) {
      console.warn('[MAMBA] Bundle discount sync failed', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync(delay = 80) {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(reconcileBundleDiscounts, delay);
  }

  const patchedFetch = async (...args) => {
    const response = await nativeFetch(...args);
    try {
      const input = args[0];
      const url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url) && !syncing) {
        scheduleSync(120);
      }
    } catch (_) {}
    return response;
  };

  window.fetch = patchedFetch;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleSync(20), { once: true });
  } else {
    scheduleSync(20);
  }

  window.addEventListener('pageshow', () => scheduleSync(40));
})();